import { observer } from 'mobx-react';
import { Component } from 'react';

import { CssAnimation } from '../../../shared/animations';
import { AnimatedComponent } from '../AnimatedComponent';
import type { AnimatedComponentProps } from '../AnimatedComponent';
import css from './AnimatedSummaryTab.css';

export class SummaryTabAnimations {
  hide: CssAnimation;
  show: CssAnimation;
  disabled: CssAnimation;

  constructor() {
    this.hide = new CssAnimation();
    this.show = new CssAnimation();
    this.disabled = new CssAnimation();
  }
}

@observer
export class AnimatedSummaryTab extends Component<AnimatedComponentProps, {}> {
  constructor(props: AnimatedComponentProps) {
    super(props);
  }

  render() {
    return <AnimatedComponent {...this.props} css={css} />;
  }
}
